mutation UpdateMerchOverlayVisibility(
  $merchOverlayId: ID!
  $extensionVisible: Boolean
) {
  overlay: StreamToolsUpdateMerchOverlay(
    merchOverlayId: $merchOverlayId
    extensionVisible: $extensionVisible
  ) {
    merchOverlayId
    name
    storeTitle
    mode
    displayStyle
    extensionVisible
    extensionDelayMs
    autoReorder
    extensionStartCollapsed
    extensionStartWidthPct
    extensionChannelLogin
    extensionChannelId
    shopMode
    shopLabelText
    ctaText
    shopDomain
    items {
      productId
      title
      priceCents
      basePriceCents
      imageUrl
      imageUrls
      featuredImage
      linkUrl
      defaultVariantId
      variantOptionName
      variantOptions {
        id
        label
        linkUrl
      }
    }
    style {
      titleColor
      titleFontKey
      productTitleColor
      productTitleFontKey
      priceFontKey
      boardBgColor
      rowBgColor
      tileBgColor
      outerBgColor
      outerCornerRadius
      boardCornerRadius
      outerBorderColor
      outerBorderWidth
      tabOutlineColor
      tabTextColor
      changeAnimation
      tweenMs
      showVariants
      squarePhotos
      offsiteMarkColor
      textGlowPx
      textGlowColor
      textGlowArrows
      outerPadX
      boardPadX
      shopLabelColor
      ctaColor
      outerPadTop
      outerPadBottom
      boardBgImage
      productImageHeight
      rowBorderColor
      collapseXSize
      collapseXColor
    }
    messages {
      id
      label
      labelColor
      text
    }
    tickerStyle {
      fontKey
      bottomBgColor
      bottomOpacity
      bottomPadTop
      bottomPadBottom
      pageBackground
      topBgColor
      textColor
      borderColor
      borderWidth
      gapHeight
      gapColor
      topPadTop
      topPadBottom
      topOuterPad
      bottomOuterPad
      scrollSpeedPxS
      changeAnimation
      topTextSizePx
      topLineHeightPx
      bottomTextSizePx
      bottomLineHeightPx
      tweenMs
      bottomScrollReverse
      textGlowPx
      textGlowColor
      topSeparatorGapPx
      bottomSeparatorGapPx
      textGlowArrows
      priceSlotMinCents
      priceSlotMaxCents
      pctSlotMaxPct
      labelFontWeight
      messageFontWeight
    }
    createdAt
    updatedAt
  }
}
